
export const mockThread = {
  it: [
    {
      chunks: [
        'Sarò a Pesaro con la mia famiglia a giugno. Siamo tutti appassionati di arte e natura. Cosa ci consigli di fare qui?\n',
      ],
      role: 'user',
    },
    /*
    {
      chunks: [
        { "type": "string", "content": "Un attimo di pazienza! Sto cercando gli eventi adatti a te!   - **Maggiori informazioni**: [clicca qui](https://pesaro2024.it/experience-event/?id=408)\n [Scopri di più.](https://pesaro2024.it/experience-event/?id=168)\n   ![](https://api.pesaro.entourance.com/uploads/images/1706001095-photo_2024-01-23%2010.10.09.jpeg) ![](https://api.pesaro.entourance.com/uploads/images/1706001095-photo_2024-01-23%2010.10.09.jpeg) ![](https://api.pesaro.entourance.com/uploads/images/1706001095-photo_2024-01-23%2010.10.09.jpeg)\n" },
        { "date": "01/01/2024 - 31/12/2024", "description": "<p><a href=\"https://pesaro2024.it/poi/?id=466\"><strong>Museo Officine Benelli</strong></a></p>\n<p> </p>\n<p><em>Apertura ordinaria</em></p>\n<p> </p>\n<p><strong>dal lunedì al sabato</strong></p>\n<p>9:00 / 13:00 e 16:30 / 19:00 </p>\n<p> </p>\n<p><strong>Stradomenica (teza domenica del...", "id": 408, "image": "https://api.pesaro.entourance.com/uploads/images/1706269631-Benelli.jpg", "place": "Pesaro, Viale Goffredo Mameli 22, PU", "time": "", "title": "Apertura Museo Officine Benelli", "type": "eventItem", "url": "https://pesaro2024.it/experience-event/?id=408" },
        { "date": "21/01/2024 - 15/12/2024", "description": "<p>L’Università dell’Età libera di Pesaro presenta “Classici per un anno”, II edizione 2024.</p>\n<p>Dodici appuntamenti con la grande letteratura in dodici luoghi di grande bellezza della provincia di Pesaro e Urbino</p>\n<p> </p>\n<p><strong>21...", "id": 337, "image": "https://api.pesaro.entourance.com/uploads/images/1704810354-Locandina.jpg", "place": "Pesaro, Largo Aldo Moro 12, PU", "time": "", "title": "Classici per un anno", "type": "eventItem", "url": "https://pesaro2024.it/experience-event/?id=337" },
        { "date": "22/01/2024 - 31/12/2024", "description": "<p><em>Promuovere i prodotti del territorio coniugando cultura e tradizione, 100 bar aderenti nel territorio provinciale diventeranno hub di #Pesaro2024 distribuendo prodotti locali e informazioni sul programma culturale.</em></p>\n<p> </p>\n<p><strong>Appuntamenti...", "id": 246, "image": "https://api.pesaro.entourance.com/uploads/images/1707486369-Schermata 1920x1080.jpeg", "place": "Pesaro, Largo Aldo Moro 12, PU", "time": "", "title": "Cosa c'è DOP", "type": "eventItem", "url": "https://pesaro2024.it/experience-event/?id=246" },
        { "date": "01/03/2024 - 30/09/2024", "description": "<p><strong>MARCHE | 1 marzo - 30 settembre</strong></p>\n<p> </p>\n<p>Il progetto <strong>ARBOR</strong>, dal latino Albero, nasce dal puro desiderio di avvicinarmi alla natura, di lavorare nei boschi e in luoghi speciali, di potermi ispirare sul luogo, lasciare che un albero mi parli, sentire il...", "id": 482, "image": "https://api.pesaro.entourance.com/uploads/images/1707384529-Pesaro 2024 - Illustrazione Cristina Spanò.jpg", "place": "Pesaro, Largo Aldo Moro 12, PU", "time": "", "title": "Arbor / Sculture biodegradabili sui tronchi degli alberi", "type": "eventItem", "url": "https://pesaro2024.it/experience-event/?id=482" },
        { "date": "01/03/2024 - 31/10/2024", "description": "<p>Ridonare alla città urbanizzata il verde di cui, troppo spesso, si sente la mancanza.  Attraverso un percorso partecipato viene definito un progetto di ‘bosco itinerante’ per Pesaro. L’idea ispiratrice viene direttamente da Leeuwarden (Olanda) - anche Capitale della cultura 2018 - che con il...", "id": 166, "image": "https://api.pesaro.entourance.com/uploads/images/1699352215-Bosco.jpeg", "place": "Pesaro, Largo Aldo Moro 12, PU", "time": "", "title": "Bosco itinerante", "type": "eventItem", "url": "https://pesaro2024.it/experience-event/?id=166" },
        { "type": "string", "content": "Ecco alcuni eventi e luoghi che potete visitare a Pesaro di martedì:\n" },
        { "type": "string", "content": "1. **Apertura Museo Officine Benelli**\n" },
        { "type": "string", "content": "   - **Descrizione**: Il Museo Officine Benelli offre un'apertura ordinaria dove potrete esplorare la storia e i modelli iconici della celebre casa motociclistica.\n" },
        { "type": "string", "content": "   - **Luogo**: Pesaro, Viale Goffredo Mameli 22\n" },
        { "type": "string", "content": "   - **Orari**: 9:00 / 13:00 e 16:30 / 19:00 (dal lunedì al sabato)\n" },
        { "type": "string", "content": "   - **Periodo**: Tutto l'anno\n" },
        { "type": "string", "content": "   - **Maggiori informazioni**: [clicca qui](https://pesaro2024.it/experience-event/?id=408)\n" },
        { "type": "string", "content": "2. **Classici per un anno**\n" },
        { "type": "string", "content": "   - **Descrizione**: Un ciclo di dodici appuntamenti dedicati alla grande letteratura, ospitati in luoghi di grande bellezza della provincia di Pesaro e Urbino.\n" },
        { "type": "string", "content": "   - **Luogo**: Pesaro, Largo Aldo Moro 12\n" },
        { "type": "string", "content": "   - **Periodo**: 21/01/2024 - 15/12/2024\n" },
        { "type": "string", "content": "   - **Maggiori informazioni**: [clicca qui](https://pesaro2024.it/experience-event/?id=337)\n" },
        { "type": "string", "content": "3. **Cosa c'è DOP**\n" },
        { "type": "string", "content": "   - **Descrizione**: Una promozione dei prodotti del territorio che coniuga cultura e tradizione, con 100 bar nel territorio provinciale che diventano hub di Pesaro2024.\n" },
        { "type": "string", "content": "   - **Luogo**: Pesaro, Largo Aldo Moro 12\n" },
        { "type": "string", "content": "   - **Periodo**: 22/01/2024 - 31/12/2024\n" },
        { "type": "string", "content": "   - **Maggiori informazioni**: [clicca qui](https://pesaro2024.it/experience-event/?id=246)\n" },
        { "type": "string", "content": "4. **Arbor / Sculture biodegradabili sui tronchi degli alberi**\n" },
        { "type": "string", "content": "   - **Descrizione**: Un progetto artistico che celebra la natura attraverso sculture biodegradabili create direttamente sui tronchi degli alberi.\n" },
        { "type": "string", "content": "   - **Luogo**: Pesaro, Largo Aldo Moro 12\n" },
        { "type": "string", "content": "   - **Periodo**: 01/03/2024 - 30/09/2024\n" },
        { "type": "string", "content": "   - **Maggiori informazioni**: [clicca qui](https://pesaro2024.it/experience-event/?id=482)\n" },
        { "type": "string", "content": "5. **Bosco itinerante**\n" },
        { "type": "string", "content": "   - **Descrizione**: Un'iniziativa per ridonare alla città urbanizzata il verde di cui si sente la mancanza, attraverso un progetto di bosco itinerante per Pesaro.\n" },
        { "type": "string", "content": "   - **Luogo**: Pesaro, Largo Aldo Moro 12\n" },
        { "type": "string", "content": "   - **Periodo**: 01/03/2024 - 31/10/2024\n" },
        { "type": "string", "content": "   - **Maggiori informazioni**: [clicca qui](https://pesaro2024.it/experience-event/?id=166)\n" },
        { "type": "string", "content": "Questi eventi rappresentano solo una parte delle numerose attività e luoghi di interesse che Pesaro offre durante il suo anno speciale come Capitale della Cultura 2024." }
      ],
      role: 'assistant',
    },
    {
      chunks: [
        'Ok grazie\n',
      ],
      role: 'user',
    },
    */
    {
      chunks: [
        'Fammi pensare, quanti anni hanno i tuoi figli?\n',
      ],
      role: 'assistant',
    },
    {
      chunks: [
        '17 e 13.',
      ],
      role: 'user',
    },
    {
      chunks: [
        'Ottimo! Niente batte il girovagare tra arte e natura con i propri piccoli! Ho selezionato un sacco di cose da fare, pensate proprio per voi.\n',
        'Dai un\'occhiata, approfondisci gli eventi e le attività che ti attirano di più e se ti serve altro mi trovi qui!\n',
        'Ecco una lista di eventi e attività selezionate dal sito adatte anche a ragazzi di quella età che si tengono a giugno o in generale:\n',
        {
          type: 'eventItem' as const,
          id: 'xxxx',
          title: 'Percorri la Bicipolitana di Pesaro con i tuoi bambini',
          abstract: 'Un’esperienza da non perdere se visiterai la città con i bambini, noleggia la tua bici e esplora Pesaro.',
          place: 'Pesaro',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/bicipolitana.jpg',
          date: '15-16 giugno 2024',
          time: 'ore 20:00',
        },
        {
          type: 'eventItem' as const,
          id: '100',
          title: 'Non perderti The Magic Castle di Gradara!',
          abstract: 'The Magic Castle, l’evento per famiglie che ogni estate trasforma magicamente lo splendido borgo di Gradara.',
          place: 'Gradara',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/gradara.jpg',
          date: '15-16 giugno 2024',
          time: 'ore 20:00',
        },
        {
          type: 'eventItem' as const,
          id: 'xxxx',
          title: 'Trekking e panorami mozzafiato al San Bartolo',
          abstract: 'Scendendo lungo la costa Adriatica, si erge il San Bartolo, un meraviglioso parco naturale affacciato sul mare.',
          place: 'Parco San Bartolo',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/san-bartolo.jpg',
          date: '15-16 giugno 2024',
          time: 'ore 20:00',
        },
        'Per qualunque altra cosa sono qui. 🙂\n',
      ],
      role: 'assistant',
    },
    {
      chunks: [
        'E se piove?\n',
      ],
      role: 'user',
    },
    {
      chunks: [
        'D\'estate piove meno, ma quando succede è proprio una scocciatura. Speriamo di evitarla, ma nel caso non ti lascio di certo scoperto!\n',
        'Ti ho preparato una lista di cose da fare al chiuso.\n',
        'Ecco una lista di eventi e attività selezionate dal sito adatte a ragazzi di quella età che si tengono a giugno o in generale ma al chiuso:\n',
        {
          type: 'eventItem' as const,
          id: '310',
          title: 'Esplora la casa del grande compositore Rossini',
          abstract: 'Rossini è stato un grande compositore italiano della prima metà del XIX secolo, vieni ad esplorare la sua casa natale.',
          place: 'Casa Rossini',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/casa-rossini.jpg',
          date: '15-16 giugno 2024',
          time: 'ore 20:00',
        },
        {
          type: 'eventItem' as const,
          id: '305',
          title: 'Vivi un’esperienza sonora incredibile alla Sonosfera©',
          abstract: 'Questo Teatro per l’ascolto profondo di ecosistemi e musica è un’esperienza unica al mondo.',
          place: 'Sonosfera',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/sonosfera.jpg',
          date: '15-16 giugno 2024',
          time: 'ore 20:00',
        },
        {
          type: 'eventItem' as const,
          id: 'xxxx',
          title: 'Sperimenta con la scienza al Museo del Balì',
          abstract: 'Il museo del Balì rispecchia la filosofia “hands-on”, Vietato NON toccare! Divertiti con le sue installazioni interattive.',
          place: 'Museo del Balì',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/museo-del-bali.jpg',
          date: '15-16 giugno 2024',
          time: 'ore 20:00',
        },
        'Vorresti sapere altro?. 🙂\n',
      ],
      role: 'assistant',
    },
    {
      chunks: [
        'Ci sono eventi o iniziative specifiche per i bambini alla Casa Rossini durante il mese di giugno?\n',
      ],
      role: 'user',
    },
    {
      chunks: [
        'Certo! A giugno ci sono alcune iniziative che possono essere interessanti e divertenti per i tuoi ragazzi, ho pensato di proporti queste:\n',
        {
          type: 'event' as const,
          id: '234',
          title: 'Rossini Virtual Experience: esplora casa Rossini in AR',
          abstract: 'Lasciati guidare dallo stesso Gioacchino nella sua casa e scopri la sua storia attraverso giocosi aneddoti in AR.',
          place: 'Pesaro',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/rossini.jpg',
          date: '15-16 giugno 2024',
          time: 'ore 20:00',
        },
      ],
      role: 'assistant',
    },
    {
      chunks: [
        'Puoi anche consigliarmi dove mangiare del buon cibo tipico, specialmente pesce, a un prezzo ragionevole?\n',
      ],
      role: 'user',
    },
    {
      chunks: [
        'Bene! Mangiando piatti locali assaporerei la vera cultura pesarese!\n',
        'ho pensato per te alcuni ristoranti che fanno pesce in modo tipico, sono adatti alle famiglie con ragazzi e non sono troppo costosi, vediamo se fanno per te:\n',
        {
          type: 'tripadvisor' as const,
          id: 'xxxx',
          title: 'L\'Angolo di Mario',
          rating: 4.8,
          reviews: 2276,
          priceRange: '€€-€€€',
          cuisine: 'Italiana, Pesce, Mediterranea',
          address: 'Via Nazario Sauro, 61100 Pesaro PU',
          url: 'https://design.wslabs.it/llm',
          book: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/tripadvisor-01.jpg',
        }, {
          type: 'tripadvisor' as const,
          id: 'xxxx',
          title: 'L\'Amo Osteria di Mare',
          rating: 4.2,
          reviews: 287,
          priceRange: '€€-€€€',
          cuisine: 'Italiana, Pesce, Mediterranea',
          address: 'Via Venturini 4/6, 61121 Pesaro PU',
          url: 'https://design.wslabs.it/llm',
          book: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/tripadvisor-02.jpg',
        }, {
          type: 'tripadvisor' as const,
          id: 'xxxx',
          title: 'Osteria Marconi',
          rating: 3.5,
          reviews: 175,
          priceRange: '€€-€€€',
          cuisine: 'Italiana, Pesce, Mediterranea',
          address: 'Viale Guglielmo Marconi 55, 61121 Pesaro PU',
          url: 'https://design.wslabs.it/llm',
          book: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/tripadvisor-03.jpg',
        }, {
          type: 'tripadvisor' as const,
          id: 'xxxx',
          title: 'Ristorante Marino',
          rating: 4.5,
          reviews: 25,
          priceRange: '€€-€€€',
          cuisine: 'Italiana, Pesce, Mediterranea',
          address: 'Str. Panoramica Adriatica, 61121 Pesaro PU',
          url: 'https://design.wslabs.it/llm',
          book: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/tripadvisor-04.jpg',
        }, {
          type: 'tripadvisor' as const,
          id: 'xxxx',
          title: 'Ristorante Pizzeria Giro di Boa',
          rating: 4.5,
          reviews: 474,
          priceRange: '€€-€€€',
          cuisine: 'Italiana, Pesce, Mediterranea',
          address: 'Viale Trieste, 277, 61121 Pesaro PU',
          url: 'https://design.wslabs.it/llm',
          book: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/tripadvisor-05.jpg',
        }, {
          type: 'tripadvisor' as const,
          id: 'xxxx',
          title: 'Taverna del Pescatore',
          rating: 4.5,
          reviews: 811,
          priceRange: '€€-€€€',
          cuisine: 'Italiana, Pesce, Mediterranea',
          address: 'Borgata Casteldimezzo, 23, 61121 Pesaro PU',
          url: 'https://design.wslabs.it/llm',
          book: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/tripadvisor-06.jpg',
        },
      ],
      role: 'assistant',
    },
    {
      chunks: [
        'Sì\n',
      ],
      role: 'user',
    },
  ],
  en: [
    {
      chunks: [
        'I will be in Pesaro with my family in June. We are all passionate about art and nature. What do you recommend we do here?\n',
      ],
      role: 'user',
    },
    {
      chunks: [
        'Let me think, how old are your kids?\n',
      ],
      role: 'assistant',
    },
    {
      chunks: [
        '17 and 13.',
      ],
      role: 'user',
    },
    {
      chunks: [
        'Optimal! Nothing beats wandering around art and nature with your little ones! I have selected a lot of things to do designed just for you.\n',
        'Take a look, learn more about the events and activities that attract you most and if you need anything else, you can find me here!\n',
        'Here is a list of events and activities selected by the site also suitable for children of that age that take place in June or in general:\n',
        {
          type: 'eventItem' as const,
          id: 'xxxx',
          title: 'Ride along the Bicipolitana of Pesaro with your children',
          abstract: 'An experience not to be missed if you visit the city with children, rent your bike and explore Pesaro.',
          place: 'Pesaro',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/bicipolitana.jpg',
          date: '15-16 june 2024',
          time: '8:00 pm',
        },
        {
          type: 'eventItem' as const,
          id: '100',
          title: 'Don\'t miss The Magic Castle of Gradara!',
          abstract: 'The Magic Castle, the family event that magically transforms the splendid village of Gradara every summer.',
          place: 'Gradara',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/gradara.jpg',
          date: '15-16 june 2024',
          time: '8:00 pm',
        },
        {
          type: 'eventItem' as const,
          id: 'xxxx',
          title: 'Trekking and breathtaking views at San Bartolo',
          abstract: 'Going down the Adriatic coast, stands San Bartolo, a wonderful natural park overlooking the sea.',
          place: 'Parco San Bartolo',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/san-bartolo.jpg',
          date: '15-16 june 2024',
          time: '8:00 pm',
        },
        'For anything else I\'m here. 🙂\n',
      ],
      role: 'assistant',
    },
    {
      chunks: [
        'What if it rains?\n',
      ],
      role: 'user',
    },
    {
      chunks: [
        'In the summer it rains less, but when it happens it\'s a real nuisance. We hope to avoid it, but if we do, I certainly won\'t leave you exposed!\n',
        'I\'ve prepared a list of things for you to do indoors.\n',
        'Here is a list of events and activities selected by the site suitable for children of that age that take place in June or in general but indoors:\n',
        {
          type: 'eventItem' as const,
          id: '310',
          title: 'Explore the home of the great composer Rossini',
          abstract: 'Rossini was a great Italian composer of the first half of the 19th century, come and explore his birthplace.',
          place: 'Rossini House',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/casa-rossini.jpg',
          date: '15-16 jun 2024',
          time: '8:00 pm',
        },
        {
          type: 'eventItem' as const,
          id: '305',
          title: 'Live an incredible sound experience at Sonosfera©',
          abstract: 'This Theater for deep listening to ecosystems and music is a unique experience in the world.',
          place: 'Sonosfera',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/sonosfera.jpg',
          date: '15-16 june 2024',
          time: '8:00 pm',
        },
        {
          type: 'eventItem' as const,
          id: 'xxxx',
          title: 'Experiment with science at the Balì Museum',
          abstract: 'The Balì museum reflects the "hands-on" philosophy, DO NOT touch! Have fun with its interactive installations.',
          place: 'Balì Museum',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/museo-del-bali.jpg',
          date: '15-16 june 2024',
          time: '8:00 pm',
        },
        'Would you like to know more?. 🙂\n',
      ],
      role: 'assistant',
    },
    {
      chunks: [
        'Are there specific events or initiatives for children at Casa Rossini during the month of June?\n',
      ],
      role: 'user',
    },
    {
      chunks: [
        'Certain! In June there are some initiatives that can be interesting and fun for your kids, I thought I\'d offer you these:\n',
        {
          type: 'event' as const,
          id: '234',
          title: 'Rossini Virtual Experience: explore Rossini\'s home in AR',
          abstract: 'Let Gioacchino himself guide you through his home and discover his story through playful anecdotes in AR.',
          place: 'Pesaro',
          url: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/rossini.jpg',
          date: '15-16 june 2024',
          time: '8:00 pm',
        },
      ],
      role: 'assistant',
    },
    {
      chunks: [
        'Can you also advise me where to eat good typical food, especially fish, at a reasonable price?\n',
      ],
      role: 'user',
    },
    {
      chunks: [
        'Well! By eating local dishes I would savor the true culture of Pesaro!\n',
        'I have thought of some restaurants for you that do fish in a typical way, are suitable for families with children and are not too expensive, let\'s see if they are for you:\n',
        {
          type: 'tripadvisor' as const,
          id: 'xxxx',
          title: 'L\'Angolo di Mario',
          rating: 4.8,
          reviews: 2276,
          priceRange: '€€-€€€',
          cuisine: 'Italiana, Pesce, Mediterranea',
          address: 'Via Nazario Sauro, 61100 Pesaro PU',
          url: 'https://design.wslabs.it/llm',
          book: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/tripadvisor-01.jpg',
        }, {
          type: 'tripadvisor' as const,
          id: 'xxxx',
          title: 'L\'Amo Osteria di Mare',
          rating: 4.2,
          reviews: 287,
          priceRange: '€€-€€€',
          cuisine: 'Italiana, Pesce, Mediterranea',
          address: 'Via Venturini 4/6, 61121 Pesaro PU',
          url: 'https://design.wslabs.it/llm',
          book: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/tripadvisor-02.jpg',
        }, {
          type: 'tripadvisor' as const,
          id: 'xxxx',
          title: 'Osteria Marconi',
          rating: 3.5,
          reviews: 175,
          priceRange: '€€-€€€',
          cuisine: 'Italiana, Pesce, Mediterranea',
          address: 'Viale Guglielmo Marconi 55, 61121 Pesaro PU',
          url: 'https://design.wslabs.it/llm',
          book: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/tripadvisor-03.jpg',
        }, {
          type: 'tripadvisor' as const,
          id: 'xxxx',
          title: 'Ristorante Marino',
          rating: 4.5,
          reviews: 25,
          priceRange: '€€-€€€',
          cuisine: 'Italiana, Pesce, Mediterranea',
          address: 'Str. Panoramica Adriatica, 61121 Pesaro PU',
          url: 'https://design.wslabs.it/llm',
          book: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/tripadvisor-04.jpg',
        }, {
          type: 'tripadvisor' as const,
          id: 'xxxx',
          title: 'Ristorante Pizzeria Giro di Boa',
          rating: 4.5,
          reviews: 474,
          priceRange: '€€-€€€',
          cuisine: 'Italiana, Pesce, Mediterranea',
          address: 'Viale Trieste, 277, 61121 Pesaro PU',
          url: 'https://design.wslabs.it/llm',
          book: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/tripadvisor-05.jpg',
        }, {
          type: 'tripadvisor' as const,
          id: 'xxxx',
          title: 'Taverna del Pescatore',
          rating: 4.5,
          reviews: 811,
          priceRange: '€€-€€€',
          cuisine: 'Italiana, Pesce, Mediterranea',
          address: 'Borgata Casteldimezzo, 23, 61121 Pesaro PU',
          url: 'https://design.wslabs.it/llm',
          book: 'https://design.wslabs.it/llm',
          image: 'https://design.wslabs.it/llm/media/tripadvisor-06.jpg',
        },
      ],
      role: 'assistant',
    },
  ],
};
